import CloseIcon from "@mui/icons-material/Close";
import { Alert, Collapse, IconButton } from "@mui/material";

/**
 * ValidationAlert component.
 *
 * This component renders an alert message that can be collapsed and closed by clicking a button.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {boolean} props.inputOpen - Whether the alert is open or closed.
 * @param {function} props.setInputClosed - Function to set the state of `inputOpen` to `false`.
 * @param {"error"|"warning"|"info"} props.severity - The severity level of the alert.
 * @param {string} props.alertMessage - The message displayed within the alert.
 *
 * @returns {JSX.Element} - The JSX element for the validation alert component.
 */
export function ValidationAlert({ inputOpen, setInputClosed, severity, alertMessage }) {
  return (
    <Collapse in={inputOpen}>
      <Alert
        severity={severity}
        action={
          <IconButton aria-label="close" color="inherit" size="small" onClick={setInputClosed}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2, whiteSpace: "pre-line" }} // Preserve line breaks in the alert message
      >
        {alertMessage}
      </Alert>
    </Collapse>
  );
}
